// extracted by mini-css-extract-plugin
export default {"allContainer":"coordinators_allContainer__4lV6a","coordinatorsContainer":"coordinators_coordinatorsContainer__BFpV7","cardGrid":"coordinators_cardGrid__3Xun3"};